import axios from "axios";
import { getToken } from "../utils/getToken";

const service = axios.create({
  baseURL: "/api"
});

service.interceptors.request.use(
  (config) => {
    if (!config.url?.includes("/login")) {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default service;
